module.exports = __webpack_public_path__ + "static/media/image1.66624461.jpg";